function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LessonListTemplate = require('./manager-main.template');
var LessonMenuTemplate = require('./manager-right.template');
var TeaserTemplate = require('./teaser.template');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var LessonManager = /*#__PURE__*/function () {
  function LessonManager(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-main';
    _classCallCheck(this, LessonManager);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.waiting_to_display = false;
    this.level = '';
    this.loader = new SaitoLoader(app, mod, '#popup-intersection');

    //////////////////////////////
    // load more on scroll-down //
    //////////////////////////////
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          _this.showLoader();
        }
      });
    }, {
      root: null,
      rootMargin: '30px',
      threshold: 1
    });
  }
  return _createClass(LessonManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
      this.level = level;

      //
      // stop observering while we rebuild the page
      //
      this.intersectionObserver.disconnect();

      //
      // insert list of lessons into .saito-main
      //
      document.querySelector('.saito-main').innerHTML = '';
      document.querySelector('.saito-sidebar.right').innerHTML = '';
      this.app.browser.addElementToSelector(LessonListTemplate(), '.saito-main');
      this.app.browser.addElementToSelector(LessonMenuTemplate(), '.saito-sidebar.right');
      this.showLoader();
      if (this.mod.lessons.length == 0) {
        this.waiting_to_display = true;
      } else {
        this.waiting_to_display = false;
      }
      for (var i = 0; i < this.mod.lessons.length; i++) {
        if (level === 'all' || this.mod.lessons[i].userslug === level) {
          this.app.browser.addElementToSelector(TeaserTemplate(this.mod.lessons[i]), '.lessons');
        }
      }
      setTimeout(function () {
        _this2.hideLoader();
      }, 50);

      //
      // enable intersection observer
      //
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      try {
        document.querySelector('.absolute-beginners').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/absolute-beginners');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'absolute-beginners');
        };
        document.querySelector('.elementary').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/elementary');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'elementary');
        };
        document.querySelector('.intermediate').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/intermediate');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'intermediate');
        };
        document.querySelector('.advanced').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/advanced');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'advanced');
        };
        document.querySelector('.film-friday').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/film-friday');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'film-friday');
        };
        document.querySelector('.quiz-night').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/quiz-night');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'quiz-night');
        };
        document.querySelector('.short-stories').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/short-stories');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'short-stories');
        };
        document.querySelector('.ktv-wednesday').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/ktv-wednesday');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'ktv-wednesday');
        };

        //
        // click to lesson
        //
        document.querySelectorAll('.teaser').forEach(function (el) {
          el.onclick = function (e) {
            var lesson_id = e.currentTarget.id;
            _this3.app.connection.emit('popup-lesson-render-request', lesson_id);
          };
        });

        //
        // dynamic content loading
        //
        var ob = document.getElementById('popup-intersection');
        if (ob) {
          this.intersectionObserver.observe(ob);
        }
        document.querySelector('.absolute-beginners').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/absolute-beginners');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'absolute-beginners');
        };
        document.querySelector('.elementary').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/elementary');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'elementary');
        };
        document.querySelector('.intermediate').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/intermediate');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'intermediate');
        };
        document.querySelector('.advanced').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/advanced');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'advanced');
        };
        document.querySelector('.film-friday').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/film-friday');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'film-friday');
        };
        document.querySelector('.quiz-night').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons/quiz-night');
          history.replaceState(null, null, ' ');
          _this3.app.connection.emit('popup-lessons-render-request', 'quiz-night');
        };
      } catch (err) {}
    }
  }, {
    key: "showLoader",
    value: function showLoader() {
      this.loader.show();
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      this.loader.hide();
    }
  }]);
}();
module.exports = LessonManager;